module.exports = __webpack_public_path__ + "media/images/version_merge/why_us_girl-e7df4bcbc38a570ecbe5ebe4876ebe9c.jpg";